var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColour({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_colour",
    "data-name": "icon colour",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pantone",
    d: "M3.479,2A1.481,1.481,0,0,0,2,3.479v8.59A1.932,1.932,0,0,0,3.93,14h8.59A1.481,1.481,0,0,0,14,12.521v-1.6A1.481,1.481,0,0,0,12.521,9.44h-.684l.848-.489a1.481,1.481,0,0,0,.541-2.021l-.8-1.387A1.481,1.481,0,0,0,10.6,4.91a1.482,1.482,0,0,0-.634-1.83l-1.387-.8a1.479,1.479,0,0,0-2.021.542l-.085.148A1.482,1.482,0,0,0,5.08,2ZM3.155,3.479a.325.325,0,0,1,.324-.324h1.6a.325.325,0,0,1,.324.324v9.366H3.93a.776.776,0,0,1-.775-.775Zm3.4,1.642L7.554,3.4A.324.324,0,0,1,8,3.279l1.386.8a.325.325,0,0,1,.119.443L6.56,9.62ZM10.983,6a.325.325,0,0,1,.443.119l.8,1.386a.325.325,0,0,1-.119.443L7.232,10.766l2.25-3.9ZM6.56,12.487,9.837,10.6h2.684a.325.325,0,0,1,.324.324v1.6a.325.325,0,0,1-.324.324H6.56ZM4.287,11.135a.578.578,0,1,0,.577.578A.577.577,0,0,0,4.287,11.135Z",
    transform: "translate(-2 -2)",
    fill: "#888",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColour);
export default __webpack_public_path__ + "static/media/colour.4832e8a197f79e9e45596e6f37ad574e.svg";
export { ForwardRef as ReactComponent };